document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-fbt]').forEach((container) => {

    const mainProduct = container.querySelector('[data-fbt-main-product]');
    const checkboxes = container.querySelectorAll('.fbt__checkbox');

    const countElement = container.querySelector('[data-fbt-count]');
    const totalElement = container.querySelector('[data-fbt-total]');
    const addButton = container.querySelector('[data-fbt-add]');
    const messageElement = container.querySelector('[data-fbt-message]');

    if (!mainProduct || !addButton) return;


    /*
     * FORMULARIO PRINCIPAL DE BROADCAST
     */
    function getProductForm() {

      return document.querySelector(
        'form[action*="/cart/add"]'
      );

    }


    /*
     * VARIANTE ACTUAL
     */
    function getCurrentVariantId() {

      const form = getProductForm();

      if (!form) {
        return Number(mainProduct.dataset.variantId);
      }

      const variantInput = form.querySelector('[name="id"]');

      if (!variantInput) {
        return Number(mainProduct.dataset.variantId);
      }

      return Number(variantInput.value);

    }


    /*
     * CANTIDAD DEL PRODUCTO PRINCIPAL
     */
    function getMainQuantity() {

      const form = getProductForm();

      if (!form) return 1;

      const quantityInput = form.querySelector(
        'input[name="quantity"]'
      );

      if (!quantityInput) return 1;

      return Math.max(
        1,
        parseInt(quantityInput.value, 10) || 1
      );

    }


    /*
     * PRECIO DEL PRODUCTO PRINCIPAL
     */
    function getMainPrice() {

      return Number(mainProduct.dataset.price);

    }


    /*
     * PRODUCTOS RELACIONADOS SELECCIONADOS
     */
    function getRelatedItems() {

      return [...checkboxes]
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => ({
          id: Number(checkbox.dataset.variantId),
          quantity: 1,
          price: Number(checkbox.dataset.price)
        }));

    }


    /*
     * FORMATEAR DINERO
     */
    function formatMoney(cents) {

      const value = cents / 100;

      const currency =
        window.Shopify?.currency?.active || 'CLP';

      return new Intl.NumberFormat(
        document.documentElement.lang || 'es-CL',
        {
          style: 'currency',
          currency: currency,
          maximumFractionDigits: currency === 'CLP' ? 0 : 2
        }
      ).format(value);

    }


    /*
     * ACTUALIZAR TOTAL
     */
    function updateSummary() {

      const mainQuantity = getMainQuantity();
      const mainPrice = getMainPrice();

      const relatedItems = getRelatedItems();

      const relatedTotal = relatedItems.reduce(
        (sum, item) => sum + item.price,
        0
      );

      const total =
        (mainPrice * mainQuantity) + relatedTotal;

      /*
       * Cantidad TOTAL de unidades.
       *
       * Ej:
       * producto principal x2
       * + relacionado A
       * + relacionado B
       * = 4 productos
       */
      const totalItems =
        mainQuantity + relatedItems.length;

      if (countElement) {

        countElement.textContent =
          totalItems === 1
            ? '1 producto'
            : `${totalItems} productos`;

      }

      if (totalElement) {
        totalElement.textContent = formatMoney(total);
      }

    }


    /*
     * CHECKBOXES
     */
    checkboxes.forEach((checkbox) => {

      checkbox.addEventListener(
        'change',
        updateSummary
      );

    });


    /*
     * OBSERVAR CAMBIOS DE CANTIDAD
     */
    document.addEventListener('change', (event) => {

      if (
        event.target.matches(
          'input[name="quantity"]'
        )
      ) {
        updateSummary();
      }

    });


    /*
     * Broadcast puede cambiar la cantidad
     * mediante botones +/- sin disparar
     * inmediatamente un change.
     */
    document.addEventListener('click', (event) => {

      const quantityButton = event.target.closest(
        '[data-quantity-plus], [data-quantity-minus], .quantity__button'
      );

      if (quantityButton) {

        setTimeout(() => {
          updateSummary();
        }, 50);

      }

    });


    /*
     * AGREGAR TODO AL CARRITO
     */
    addButton.addEventListener('click', async () => {

      const mainVariantId = getCurrentVariantId();
      const mainQuantity = getMainQuantity();

      if (!mainVariantId) return;


      /*
       * El producto principal SIEMPRE
       * forma parte de la compra.
       */
      const items = [
        {
          id: mainVariantId,
          quantity: mainQuantity
        }
      ];


      /*
       * Agregamos los relacionados marcados.
       */
      getRelatedItems().forEach((item) => {

        items.push({
          id: item.id,
          quantity: 1
        });

      });


      addButton.disabled = true;

      if (messageElement) {
        messageElement.textContent = '';
        messageElement.className = 'fbt__message';
      }


      try {

  const root =
    window.Shopify?.routes?.root || '/';

  const response = await fetch(
    `${root}cart/add.js`,
    {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        items: items
      })
    }
  );


  if (!response.ok) {

    const errorData = await response.json();

    throw new Error(
      errorData.description ||
      errorData.message ||
      'No se pudieron agregar los productos.'
    );

  }

await response.json();

document.dispatchEvent(
  new CustomEvent('theme:cart:change', {
    bubbles: true
  })
);

document.dispatchEvent(
  new CustomEvent('theme:cart:refresh', {
    bubbles: true
  })
);

setTimeout(() => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      bubbles: true
    })
  );
}, 200);

addButton.disabled = false;

  } catch (error) {

        console.error(
          'Frequently Bought Together:',
          error
        );

        if (messageElement) {

          messageElement.textContent =
            error.message ||
            'Ocurrió un error al agregar los productos.';

          messageElement.classList.add('is-error');

        }

        addButton.disabled = false;

      }

    });


    /*
     * ESTADO INICIAL
     */
    updateSummary();

  });

});